import type {
  NotifItem,
  InboxItem,
  NotifTypeConfig,
  PhotoBreakImages,
} from "./types";

/* ── Notification type styles ── */
export const NOTIF_TYPE_CONFIG: Record<string, NotifTypeConfig> = {
  call: {
    iconKey: "phone",
    color: "#ff4d6a",
    bg: "rgba(255,77,106,0.13)",
    label: "Call",
    counterColor: "#ff4d6a",
  },
  whatsapp: {
    iconKey: "whatsapp",
    color: "#25D366",
    bg: "rgba(37,211,102,0.13)",
    label: "WhatsApp",
  },
  sms: {
    iconKey: "sms",
    color: "#f5a623",
    bg: "rgba(245,166,35,0.13)",
    label: "SMS",
    counterColor: "#ff4d6a",
  },
  email: {
    iconKey: "email",
    color: "#38b6ff",
    bg: "rgba(56,182,255,0.13)",
    label: "Email",
  },
};

/* ── Inbox type styles ── */
export const INBOX_TYPE_CONFIG: Record<string, NotifTypeConfig> = {
  email: {
    iconKey: "email",
    color: "#38b6ff",
    bg: "rgba(56,182,255,0.13)",
    label: "Email",
    counterColor: "#38b6ff",
  },
  phone: {
    iconKey: "phone",
    color: "#ff4d6a",
    bg: "rgba(255,77,106,0.13)",
    label: "Phone",
  },
  whatsapp: {
    iconKey: "whatsapp",
    color: "#25D366",
    bg: "rgba(37,211,102,0.13)",
    label: "WhatsApp",
  },
  tender: {
    iconKey: "tender",
    color: "#f5a623",
    bg: "rgba(245,166,35,0.13)",
    label: "Tender",
  },
};

/* ── Notification pools ── */
export const NOTIF_POOLS: Record<string, NotifItem[]> = {
  AU: [
    { kind: "whatsapp", sender: "CC Medical", msg: "Hi! ED locum available in Perth this weekend \u2014 interested?", time: "8:02am" },
    { kind: "whatsapp", sender: "Ochre Health", msg: "Rural GP 500km away. A$320/hr. Can you do it?", time: "8:14am" },
    { kind: "call", sender: "Unknown (+61 4)", msg: "Missed call \u00b7 1 of 4", time: "8:19am", duplicateCount: 4 },
    { kind: "sms", sender: "Cornerstone Med", msg: "URGENT: ICU reg needed tonight \u2014 4 hour min. Please reply ASAP", time: "8:31am", urgent: true },
    { kind: "whatsapp", sender: "NSW Health", msg: "Band 5 nights this week, 180km from Sydney. Avail?", time: "8:44am" },
    { kind: "email", sender: "Aston Recruit", msg: "GP Locum \u00b7 Parramatta \u00b7 $180/hr \u2014 are you available Thu\u2013Sat?", time: "8:51am" },
    { kind: "sms", sender: "Locum4u", msg: "Same Parramatta GP role \u2014 $195/hr. Faster turnaround.", time: "8:53am", duplicateCount: 2 },
    { kind: "call", sender: "Medacs", msg: "Missed call \u00b7 left voicemail", time: "9:02am" },
    { kind: "whatsapp", sender: "HealthStaff", msg: "ED consultant Broken Hill \u2014 2 weeks. Interested?", time: "9:11am" },
    { kind: "sms", sender: "Ochre Health", msg: "Urgent: still need cover for weekend. Please respond.", time: "9:18am", urgent: true },
    { kind: "email", sender: "MedicsPro", msg: "Parramatta GP again \u2014 now $205/hr. Lock in today?", time: "9:22am", duplicateCount: 3 },
    { kind: "call", sender: "Private number", msg: "Missed call \u00b7 2 of 2", time: "9:34am", duplicateCount: 2 },
    { kind: "whatsapp", sender: "CC Medical", msg: "Following up on the Perth ED role \u2014 still need an answer", time: "9:41am", urgent: true },
    { kind: "sms", sender: "Cornerstone Med", msg: "ICU reg still open \u2014 can now pay $350/hr cash bonus", time: "9:48am", urgent: true },
    { kind: "email", sender: "Global Medics", msg: "New roles this week: 47 shifts across NSW/VIC/QLD attached", time: "9:55am" },
    { kind: "whatsapp", sender: "Locum4u", msg: "Are you free? Got 3 GP shifts this week. Call me.", time: "10:03am" },
    { kind: "sms", sender: "Unknown", msg: "This is Sarah from Atlas Medical \u2014 can you chat?", time: "10:09am" },
    { kind: "call", sender: "Aston Recruit", msg: "Missed call \u00b7 left voicemail", time: "10:14am" },
  ],
  UAE: [
    { kind: "whatsapp", sender: "Medacs Healthcare", msg: "Hi! ED locum available in Sharjah this weekend \u2014 interested?", time: "8:02am" },
    { kind: "whatsapp", sender: "MSI Group", msg: "Rural GP 200km away. AED 600/hr. Can you do it?", time: "8:14am" },
    { kind: "call", sender: "Unknown (+971 5)", msg: "Missed call \u00b7 1 of 4", time: "8:19am", duplicateCount: 4 },
    { kind: "sms", sender: "Globe Locums", msg: "URGENT: ICU reg needed tonight at Mediclinic \u2014 4hr min. Reply ASAP", time: "8:31am", urgent: true },
    { kind: "whatsapp", sender: "DHA Staffing", msg: "Band 5 nights this week, Al Ain. Available?", time: "8:44am" },
    { kind: "email", sender: "Fidelis Healthcare", msg: "GP Locum \u00b7 Dubai Marina \u00b7 AED 400/hr \u2014 available Thu\u2013Sat?", time: "8:51am" },
    { kind: "sms", sender: "Medacs Healthcare", msg: "Same Marina GP role \u2014 AED 430/hr. Faster turnaround.", time: "8:53am", duplicateCount: 2 },
    { kind: "call", sender: "NMC Recruitment", msg: "Missed call \u00b7 left voicemail", time: "9:02am" },
    { kind: "whatsapp", sender: "Aster DM Health", msg: "ED consultant Fujairah \u2014 2 weeks. Interested?", time: "9:11am" },
    { kind: "sms", sender: "MSI Group", msg: "Urgent: still need cover for weekend. Please respond.", time: "9:18am", urgent: true },
    { kind: "email", sender: "Globe Locums", msg: "Marina GP again \u2014 now AED 460/hr. Lock in today?", time: "9:22am", duplicateCount: 3 },
    { kind: "call", sender: "Private number", msg: "Missed call \u00b7 2 of 2", time: "9:34am", duplicateCount: 2 },
    { kind: "whatsapp", sender: "Medacs Healthcare", msg: "Following up on the Sharjah ED role \u2014 still need an answer", time: "9:41am", urgent: true },
    { kind: "sms", sender: "Globe Locums", msg: "ICU reg still open \u2014 can now offer AED 650/hr", time: "9:48am", urgent: true },
    { kind: "email", sender: "Fidelis Healthcare", msg: "New roles this week: 32 shifts across Dubai/Abu Dhabi/Sharjah attached", time: "9:55am" },
    { kind: "whatsapp", sender: "NMC Recruitment", msg: "Are you free? Got 3 GP shifts this week. Call me.", time: "10:03am" },
    { kind: "sms", sender: "Unknown", msg: "This is Layla from Aster \u2014 can you chat?", time: "10:09am" },
    { kind: "call", sender: "Fidelis Healthcare", msg: "Missed call \u00b7 left voicemail", time: "10:14am" },
  ],
  UAE_AR: [
    { kind: "whatsapp", sender: "ميداكس هيلثكير", msg: "مرحباً! وظيفة طوارئ مؤقتة في الشارقة هذا الأسبوع — مهتم؟", time: "٨:٠٢ص" },
    { kind: "whatsapp", sender: "MSI جروب", msg: "طبيب عام ٢٠٠ كم. ٦٠٠ د.إ/ساعة. تقدر؟", time: "٨:١٤ص" },
    { kind: "call", sender: "رقم مجهول", msg: "مكالمة فائتة · ١ من ٤", time: "٨:١٩ص", duplicateCount: 4 },
    { kind: "sms", sender: "غلوب لوكمز", msg: "عاجل: مسجل عناية مركزة الليلة في ميديكلينيك — ٤ ساعات كحد أدنى", time: "٨:٣١ص", urgent: true },
    { kind: "whatsapp", sender: "توظيف DHA", msg: "ورديات ليلية هذا الأسبوع، العين. متاح؟", time: "٨:٤٤ص" },
    { kind: "email", sender: "فيديليس هيلثكير", msg: "طبيب عام مؤقت · دبي مارينا · ٤٠٠ د.إ/ساعة — متاح خميس–سبت؟", time: "٨:٥١ص" },
    { kind: "sms", sender: "ميداكس هيلثكير", msg: "نفس وظيفة المارينا — ٤٣٠ د.إ/ساعة. أسرع.", time: "٨:٥٣ص", duplicateCount: 2 },
    { kind: "call", sender: "توظيف NMC", msg: "مكالمة فائتة · ترك رسالة صوتية", time: "٩:٠٢ص" },
    { kind: "whatsapp", sender: "أستر DM هيلث", msg: "استشاري طوارئ الفجيرة — أسبوعان. مهتم؟", time: "٩:١١ص" },
    { kind: "sms", sender: "MSI جروب", msg: "عاجل: لا زلنا نحتاج تغطية لنهاية الأسبوع. الرجاء الرد.", time: "٩:١٨ص", urgent: true },
    { kind: "email", sender: "غلوب لوكمز", msg: "طبيب عام المارينا مجدداً — الآن ٤٦٠ د.إ/ساعة", time: "٩:٢٢ص", duplicateCount: 3 },
    { kind: "call", sender: "رقم خاص", msg: "مكالمة فائتة · ٢ من ٢", time: "٩:٣٤ص", duplicateCount: 2 },
    { kind: "whatsapp", sender: "ميداكس هيلثكير", msg: "متابعة لوظيفة طوارئ الشارقة — لا زلنا ننتظر ردك", time: "٩:٤١ص", urgent: true },
    { kind: "sms", sender: "غلوب لوكمز", msg: "مسجل عناية مركزة لا يزال متاحاً — الآن ٦٥٠ د.إ/ساعة", time: "٩:٤٨ص", urgent: true },
    { kind: "email", sender: "فيديليس هيلثكير", msg: "وظائف جديدة هذا الأسبوع: ٣٢ وردية في دبي/أبوظبي/الشارقة", time: "٩:٥٥ص" },
    { kind: "whatsapp", sender: "توظيف NMC", msg: "متاح؟ عندي ٣ ورديات طبيب عام هذا الأسبوع. اتصل بي.", time: "١٠:٠٣ص" },
    { kind: "sms", sender: "مجهول", msg: "أنا ليلى من أستر — ممكن نتكلم؟", time: "١٠:٠٩ص" },
    { kind: "call", sender: "فيديليس هيلثكير", msg: "مكالمة فائتة · ترك رسالة صوتية", time: "١٠:١٤ص" },
  ],
};

/* ── Inbox pools ── */
export const INBOX_POOLS: Record<string, InboxItem[]> = {
  AU: [
    { type: "email", from: "Royal North Shore", msg: "We urgently need an ED consultant for this weekend, can you help?", time: "7:48am", threadCount: 3, urgent: true },
    { type: "email", from: "Westmead Hospital", msg: "Following up on our GP locum request from Friday \u2014 any candidates?", time: "9:12am", threadCount: 7 },
    { type: "phone", from: "Liverpool Medical", msg: "Missed call \u00b7 3 missed", time: "9:44am" },
    { type: "whatsapp", from: "Royal North Shore", msg: "Still looking for that ED consultant, let me know urgently", time: "11:03am", urgent: true },
    { type: "email", from: "St Vincent's", msg: "We need a paediatric reg from Tuesday, any availability?", time: "11:30am", threadCount: 2 },
    { type: "tender", from: "NSW Health eTendering", msg: "New tender: Medical Locum Services \u2014 ED/ICU \u2014 Metro Sydney. Closes Friday.", time: "11:45am" },
    { type: "whatsapp", from: "Blacktown Hospital", msg: "Hi can you cover ICU reg this Thurs/Fri? $280/hr", time: "12:03pm", urgent: true },
    { type: "email", from: "Mater Hospital", msg: "We need anaesthetics cover for Thursday \u2014 do you have anyone available?", time: "12:18pm", threadCount: 5 },
    { type: "phone", from: "Prince of Wales", msg: "Missed call \u00b7 left voicemail", time: "12:31pm" },
    { type: "tender", from: "QLD Health Procurement", msg: "Tender RFQ-7821: GP Locum Services \u2014 Regional QLD. Response due Mon.", time: "12:44pm" },
    { type: "email", from: "Children's Hospital", msg: "URGENT \u2014 Paediatric consultant needed tonight. Please respond ASAP.", time: "12:55pm", threadCount: 9, urgent: true },
    { type: "whatsapp", from: "Concord Repatriation", msg: "Please call when you can re: ortho locum for next 2 weeks", time: "1:08pm" },
    { type: "email", from: "John Hunter Hospital", msg: "Following up on geriatrics locum request \u2014 still outstanding from last week.", time: "1:22pm", threadCount: 12 },
    { type: "phone", from: "Fiona Stanley Hospital", msg: "Missed call \u00b7 left voicemail", time: "1:35pm" },
    { type: "tender", from: "WA Health Tenders", msg: "Framework invitation: Specialist Medical Locums \u2014 Perth Metro. Due Mon.", time: "1:48pm" },
    { type: "email", from: "Nepean Hospital", msg: "Hi, do you have a psychiatry locum for our 4-week residential placement?", time: "2:01pm", threadCount: 4 },
    { type: "whatsapp", from: "Northern Beaches Hosp", msg: "Need overnight cover tomorrow in ED. Any doctor available?", time: "2:14pm", urgent: true },
    { type: "email", from: "Campbelltown Hospital", msg: "Following up \u2014 have you had a chance to check doctor availability for next month?", time: "2:27pm", threadCount: 6 },
  ],
  UAE: [
    { type: "email", from: "Cleveland Clinic AD", msg: "We urgently need an ED consultant for this weekend, can you help?", time: "7:48am", threadCount: 3, urgent: true },
    { type: "email", from: "Mediclinic City Hosp", msg: "Following up on our GP locum request from Sunday \u2014 any candidates?", time: "9:12am", threadCount: 7 },
    { type: "phone", from: "Al Zahra Hospital", msg: "Missed call \u00b7 3 missed", time: "9:44am" },
    { type: "whatsapp", from: "Cleveland Clinic AD", msg: "Still looking for that ED consultant, let me know urgently", time: "11:03am", urgent: true },
    { type: "email", from: "Tawam Hospital", msg: "We need a paediatric reg from Tuesday, any availability?", time: "11:30am", threadCount: 2 },
    { type: "tender", from: "DHA Procurement", msg: "New tender: Medical Locum Services \u2014 ED/ICU \u2014 Dubai Metro. Closes Thursday.", time: "11:45am" },
    { type: "whatsapp", from: "NMC Royal Hospital", msg: "Hi can you cover ICU reg this Thu/Fri? AED 550/hr", time: "12:03pm", urgent: true },
    { type: "email", from: "Burjeel Hospital", msg: "We need anaesthetics cover for Thursday \u2014 do you have anyone available?", time: "12:18pm", threadCount: 5 },
    { type: "phone", from: "Sheikh Khalifa Med", msg: "Missed call \u00b7 left voicemail", time: "12:31pm" },
    { type: "tender", from: "HAAD Procurement", msg: "Tender RFQ-4821: GP Locum Services \u2014 Abu Dhabi. Response due Mon.", time: "12:44pm" },
    { type: "email", from: "Al Jalila Children's", msg: "URGENT \u2014 Paediatric consultant needed tonight. Please respond ASAP.", time: "12:55pm", threadCount: 9, urgent: true },
    { type: "whatsapp", from: "Rashid Hospital", msg: "Please call when you can re: ortho locum for next 2 weeks", time: "1:08pm" },
    { type: "email", from: "Mafraq Hospital", msg: "Following up on geriatrics locum request \u2014 still outstanding from last week.", time: "1:22pm", threadCount: 12 },
    { type: "phone", from: "Aster Hospital Mankhool", msg: "Missed call \u00b7 left voicemail", time: "1:35pm" },
    { type: "tender", from: "DOH Tenders", msg: "Framework invitation: Specialist Medical Locums \u2014 Abu Dhabi. Due Mon.", time: "1:48pm" },
    { type: "email", from: "Thumbay Hospital", msg: "Hi, do you have a psychiatry locum for our 4-week placement in Ajman?", time: "2:01pm", threadCount: 4 },
    { type: "whatsapp", from: "Saudi German Hosp", msg: "Need overnight cover tomorrow in ED. Any doctor available?", time: "2:14pm", urgent: true },
    { type: "email", from: "Al Qassimi Hospital", msg: "Following up \u2014 have you had a chance to check doctor availability for next month?", time: "2:27pm", threadCount: 6 },
  ],
  UAE_AR: [
    { type: "email", from: "كليفلاند كلينك أبوظبي", msg: "نحتاج بشكل عاجل استشاري طوارئ لنهاية الأسبوع، هل يمكنكم المساعدة؟", time: "٧:٤٨ص", threadCount: 3, urgent: true },
    { type: "email", from: "ميديكلينيك سيتي", msg: "متابعة لطلب طبيب عام مؤقت من يوم الأحد — أي مرشحين؟", time: "٩:١٢ص", threadCount: 7 },
    { type: "phone", from: "مستشفى الزهراء", msg: "مكالمة فائتة · ٣ فائتة", time: "٩:٤٤ص" },
    { type: "whatsapp", from: "كليفلاند كلينك أبوظبي", msg: "لا زلنا نبحث عن استشاري الطوارئ، أعلمنا بشكل عاجل", time: "١١:٠٣ص", urgent: true },
    { type: "email", from: "مستشفى توام", msg: "نحتاج مسجل أطفال من الثلاثاء، أي توفر؟", time: "١١:٣٠ص", threadCount: 2 },
    { type: "tender", from: "مشتريات DHA", msg: "مناقصة جديدة: خدمات طبية مؤقتة — طوارئ/عناية مركزة — مترو دبي", time: "١١:٤٥ص" },
    { type: "whatsapp", from: "مستشفى NMC الملكي", msg: "ممكن تغطي مسجل عناية مركزة خميس/جمعة؟ ٥٥٠ د.إ/ساعة", time: "١٢:٠٣م", urgent: true },
    { type: "email", from: "مستشفى برجيل", msg: "نحتاج تغطية تخدير ليوم الخميس — هل لديكم أحد متاح؟", time: "١٢:١٨م", threadCount: 5 },
    { type: "phone", from: "مستشفى الشيخ خليفة", msg: "مكالمة فائتة · ترك رسالة صوتية", time: "١٢:٣١م" },
    { type: "tender", from: "مشتريات HAAD", msg: "مناقصة: خدمات طبيب عام مؤقت — أبوظبي. الموعد النهائي الاثنين.", time: "١٢:٤٤م" },
    { type: "email", from: "مستشفى الجليلة للأطفال", msg: "عاجل — استشاري أطفال مطلوب الليلة. الرجاء الرد فوراً.", time: "١٢:٥٥م", threadCount: 9, urgent: true },
    { type: "whatsapp", from: "مستشفى راشد", msg: "الرجاء الاتصال بخصوص وظيفة عظام مؤقتة لأسبوعين", time: "١:٠٨م" },
    { type: "email", from: "مستشفى المفرق", msg: "متابعة طلب طبيب شيخوخة مؤقت — لا يزال معلقاً من الأسبوع الماضي.", time: "١:٢٢م", threadCount: 12 },
    { type: "phone", from: "مستشفى أستر المنخول", msg: "مكالمة فائتة · ترك رسالة صوتية", time: "١:٣٥م" },
    { type: "tender", from: "مناقصات DOH", msg: "دعوة إطارية: أطباء مؤقتون متخصصون — أبوظبي. الموعد النهائي الاثنين.", time: "١:٤٨م" },
    { type: "email", from: "مستشفى ثومبي", msg: "هل لديكم طبيب نفسي مؤقت لتعيين ٤ أسابيع في عجمان؟", time: "٢:٠١م", threadCount: 4 },
    { type: "whatsapp", from: "المستشفى السعودي الألماني", msg: "نحتاج تغطية ليلية غداً في الطوارئ. أي طبيب متاح؟", time: "٢:١٤م", urgent: true },
    { type: "email", from: "مستشفى القاسمي", msg: "متابعة — هل تحققتم من توفر الأطباء للشهر القادم؟", time: "٢:٢٧م", threadCount: 6 },
  ],
};

/* ── Photo break images by region ── */
export const PHOTO_BREAK_IMAGES: Record<string, PhotoBreakImages> = {
  AU: {
    img1: {
      src: "/images/nano-banana/rural-doctor-carpark.png",
      alt: "Doctor standing in regional hospital car park at golden hour",
    },
    img2: {
      src: "/images/nano-banana/regional-hospital-exterior.png",
      alt: "Regional Australian hospital building in morning light",
    },
    single: {
      src: "/images/nano-banana/indigenous-healthcare-worker.png",
      alt: "Indigenous Australian healthcare worker in hospital corridor",
    },
  },
  UAE: {
    img1: {
      src: "/images/nano-banana/Gemini_Generated_Image_v61t3gv61t3gv61t.png",
      alt: "Doctor in scrubs walking outside a modern Dubai medical centre",
    },
    img2: {
      src: "/images/nano-banana/Gemini_Generated_Image_viql19viql19viql.png",
      alt: "UAE Private Healthcare Center with modern glass facade",
    },
    single: {
      src: "/images/nano-banana/uae-doctor-dubai.png",
      alt: "Doctor in scrubs outside a modern Dubai medical centre",
    },
  },
};
